import { debounce } from 'lodash'
import { useEffect, useState } from 'react'

import { requestGeocoder } from './here-api'
import { GeocoderResult as GeocoderItem } from './here-api/types'
import { UseGeocoder, UseGeocoderParams } from './types'

const useGeocoder = ({
  query,
  lat,
  lon,
  limit = 5,
}: UseGeocoderParams): UseGeocoder => {
  const [results, setResults] = useState<GeocoderItem[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const fetchGeocodes = async ({ query, lat, lon }): Promise<void> => {
    try {
      if (
        !query ||
        query.length < 3 ||
        !lat ||
        !lon ||
        lat === 0 ||
        lon === 0
      ) {
        setResults([])
        return
      }

      setIsLoading(true)

      const result = await requestGeocoder({
        query,
        language: i18n.language,
        lat,
        lon,
        limit,
      })

      setError(false)
      setResults(result.items)
    } catch {
      setError(true)
      setResults([])
    } finally {
      setIsLoading(false)
    }
  }

  const debouncedRequest = debounce(fetchGeocodes, 500)

  useEffect(() => {
    debouncedRequest({ query, lat, lon })
  }, [query])

  return { results, error, isLoading }
}

export default useGeocoder
